import PropTypes from "prop-types";
import { Button, Container, } from 'reactstrap';
// import { personaPageData } from '../../common';
import * as Icons from "../../common/icons/personaPageDataIcons";

// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )


const WhyVarahiSoftSection = ({ WhyVarahiSoft }) => {
    const ArrowRoundIcon = Icons['ArrowRoundIcon'];

    return (
        <section className="why_varahiSoft-section">
            <Container className=" py-5 Demographics-container">
                <div className="Demographics">
                    <div className="Identifiers-div pb-5">
                        <div className="px-5 d-flex align-items-center justify-content-start">
                            <Button className="btn why-btn">{WhyVarahiSoft?.topButtonName}</Button>
                            <div className="img-way-line">
                                <img rel="preload" src={'/assets/images/why-button-arrow-line.svg'} alt="vector-img" />
                            </div>
                        </div>
                        <div className="w-75">
                            <div className="px-3 identifiers-list">
                                <ul className="identifiers-ul">
                                    {WhyVarahiSoft?.listData?.length > 0 && WhyVarahiSoft?.listData?.map((WhyVarahiSoft) => {
                                        return (
                                            <li key={`WhyVarahiSoft_${WhyVarahiSoft?.id}`} className="identifiers-li d-flex align-items-center gap-3 justify-content-start">
                                                <div className="identifiers-hover">
                                                    {ArrowRoundIcon && <ArrowRoundIcon />}
                                                    <img rel="preload" src={'/assets/images/second.svg'} alt="vector-img" />
                                                </div>
                                                <span>{WhyVarahiSoft?.text}</span>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
}

WhyVarahiSoftSection.propTypes = {
    classes: PropTypes.object
};

export default WhyVarahiSoftSection;
